import { render } from "./CategorySearchForm.vue?vue&type=template&id=35963b88"
import script from "./CategorySearchForm.vue?vue&type=script&lang=js"
export * from "./CategorySearchForm.vue?vue&type=script&lang=js"
script.render = render

export default script